import React          from 'react';
import Target         from './Target';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';

const errMessage1 = `העברת הביצים לא הושלמה`;
const errMessage2 = `נסו שוב`;


const useStyles = makeStyles(theme => ({
    targetContainer: {
        position:       'fixed',
        left:           '50%',
        top:            '50%',
        transform:      'translate(-50%, -50%)',
        zIndex:         1,
        display:        'flex',
        borderRadius:   '1em',
        border:         '1px solid #DDD',
       // overflow:       'hidden',
        transition:     'opacity 0.3s'
    },
    messageContainer: {
      position:        'absolute',
      top:             0,
      left:            0,
      width:           '100%',
      height:          '100%',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
   },
   message: {
   /*  height:          80,
    width:           '100%', */
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    color:            colors.blue,
   },
   failure: {
      position:        'absolute',
      width:           '100%',
      top:             '105%',
      zIndex:          3,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      color:           'red',
   },
   button: {
    height:          40,
    width:           140,
    fontSize:        20,
    marginTop:       30,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    borderRadius:    '0.5em',
    backgroundColor: colors.blue,
    color:           '#FFF',
    cursor:          'pointer',
    zIndex:          2
   },
   arrangeBoxesButton: {
    position:        'absolute',
    top:             '105%',
    left:            '50%',
    height:          40,
    width:           140,
    fontSize:        20,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    borderRadius:    '0.5em',
    backgroundColor: colors.blue,
    color:           '#FFF',
    cursor:          'pointer',
    transition:      'all 0.4s',
    zIndex:          2,
   }
}));

type TargetContainerProps = {
    correctValues:         number[];
    disabledEggsArr:       number[];
    target_size:           number;
    target0Value:          number;
    target1Value:          number;
    selectableEggs:        number;
    selectedEggs:          number;
    transferedEggs:        number;
    maxSelections:         number;
    opacity:               number;
    failureCounter:        number;
    draggedEgg:            number;
    putEggBackInBox:       boolean;
    target0Hover:          boolean;
    target1Hover:          boolean;
    reception0:            boolean;
    reception1:            boolean;
    wideScreen:            boolean;
    eggGhost:              boolean;
    ghostShake:            boolean;
    showContinueButton:    boolean;
    showFinalValue:        boolean;
    showArrangementButton: boolean;
    closeAtTen:            boolean;
    showErr:               boolean;
    stage1Complete:        boolean;
    dragOrSelect:          string;
    message:               string;
    handleEggSelection:    (ind: number, counter: number, val: number) => void;
    handleMouseDown:       (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:      (e: React.TouchEvent, ind: number) => void;
    handleButtonClick:     () => void;
    arrange:               () => void;
}


const TargetContainer: React.FC<TargetContainerProps> = ({ 
    correctValues,
    disabledEggsArr,
    target_size, 
    selectableEggs,
    selectedEggs,
    transferedEggs,
    maxSelections,
    target0Value,
    target1Value,
    target0Hover, 
    target1Hover,
    reception0,
    reception1,
    wideScreen,
    dragOrSelect,
    eggGhost,
    opacity,
    showContinueButton,
    ghostShake,
    message,
    failureCounter,
    showFinalValue,
    draggedEgg,
    putEggBackInBox,
    showErr,
    showArrangementButton,
    closeAtTen,
    stage1Complete,
    handleEggSelection,
    handleMouseDown,
    handleTouchStart,
    handleButtonClick,
    arrange
}) => {


  const classes = useStyles();

  const wrongAnswerMessage = React.useMemo(() => {

    if ( !stage1Complete ) {
      return errMessage2;
    }

    let msg = errMessage2;
  
    if (
          (
            ( correctValues[0] + correctValues[1] <= 10 ) 
           /*  && 
            (( draggedEgg > -1 ) || ( transferedEggs > 0 ))     */
            &&
            (( target0Value > 0 ) && ( target1Value > 0 ))
          )
          ||
          (
            (correctValues[0] + correctValues[1] > 10)
            &&
            (( target0Value < 10 ) && ( target1Value < 10 ))
          )       
       ) {
        msg = errMessage1;
       }
  
    return msg;
  
  },[ correctValues/* , transferedEggs, draggedEgg */, target0Value, target1Value, stage1Complete ])


  const disable = React.useMemo(() => {
    return maxSelections <= selectedEggs || maxSelections === 0;
  },[maxSelections, selectedEggs])

  
  const dontShowImage = React.useMemo(() => {
    return !target0Value && !target1Value
  },[target0Value, target1Value])


  return (
    <div 
      className = { classes.targetContainer }
      style = {{ 
        width:  target_size * 2,
        height: target_size / 2,
        opacity: opacity
      }}
    >
      {
        [-1, -2].map((val, ind) => {
          return(
            <Target
               key                = { `target${ val }&*()` }
               index              = { val }
               target_size        = { target_size }
               targetHover        = { !ind ? target0Hover : target1Hover }
               value              = { !ind ? target0Value : target1Value }
               reception          = { !ind ? reception0 : reception1 }
               selectable         = { selectableEggs === ind || selectableEggs === 2 }
               wideScreen         = { wideScreen }
               disabledEggsArr    = { disabledEggsArr }
               disable            = { disable || (selectableEggs !== ind && selectableEggs !== 2) }
               dragOrSelect       = { dragOrSelect }
               eggGhost           = { eggGhost }
               initialValue       = { correctValues[ind] }
               ghostShake         = { ghostShake }
               dontShowImage      = { dontShowImage }
               showFinalValue     = { showFinalValue }
               draggedEgg         = { draggedEgg }
               putEggBackInBox    = { putEggBackInBox }
               closeAtTen         = { closeAtTen }
               handleEggSelection = { handleEggSelection }
               handleMouseDown    = { handleMouseDown }
               handleTouchStart   = { handleTouchStart }
            />
          )
        })
      }
      <div 
            dir       = 'rtl'
            className = { classes.arrangeBoxesButton }
            onClick   = { arrange }
            style     = {{
                transform: `translate(-50%, ${ stage1Complete && showArrangementButton ? 0 : 150 }vh)`,
            }}
      >
        { `המשך` }
      </div>
      {
        target0Value === 0 && target1Value === 0
        &&
        <div className = { classes.messageContainer }>
           <div 
              dir       = 'rtl'
              className = { classes.message }
              style     = {{
                fontSize: wideScreen ? 28 : 20
             }}
           >
              { message }
           </div>
           {
             showContinueButton
             &&
             <div 
               dir       = 'rtl'
               className = { classes.button }
               onClick   = { handleButtonClick }
             >
               { `המשך` }
             </div>
           }
        </div>
      }
      {
        showErr && !showContinueButton && !showArrangementButton && failureCounter > 0
        &&
        <div 
            dir       = 'rtl'
            className = { classes.failure }
            style     = {{
              fontSize: wideScreen ? 28 : 20
           }}
        >
            { wrongAnswerMessage }
        </div>
      }
      
    </div>
  )
}
export default TargetContainer



